<template>
  <el-container :class="this.$route.path == '/index'?'scollp':''">
    <el-header :class="$route.path== '/resource/detail'?'headers detals':$route.path.split('/')[1]== 'resource'?'headers':'headers is'"  ref="header">
      <Header class="header"></Header>
      <!-- <div class="header-nav" ref="header2" >
          <div v-for="(item, index) in topList" :key="index" class="header-nva-item" @click="setBarWidth(item)" :ref="item.ref">
              {{item.title}}
          </div>
      </div> -->
      <headerBar></headerBar>
      <!-- <div class="header-nav" ref="header2">
        <div ref="navBg" class="nav-bg">
          <el-image :src="require('../../assets/image/resource/res_lovo.png')" fit="fill"></el-image>
        </div>
        <div v-for="(item, index) in topList" :key="item.ref" class="header-nva-item" @click="setBarWidth(item)"
          :ref="item.ref" :id="item.ref">
          {{ item.title }}
        </div>
      </div> -->
    </el-header>
    <el-main ref="main">
      <router-view></router-view>
    </el-main>
    <el-footer style="height: 15.625rem;">
      <Footer class="footer"></Footer>
    </el-footer>
  </el-container>
</template>

<script>
  import Header from "../../components/common/Header.vue";
  import Footer from "../../components/common/Footer.vue";
  import headerBar from "../../components/common/headerBar.vue";

  export default {
    components: {
      Header,
      Footer,
      headerBar
    },
    name: "Home",
    data() {
      return {
        fullHeight: '',
        timer: false,
        // topList:[
        //   {
        //       title:'铸牢中华民族共同体意识古籍库',
        //       ref:'zhulao'
        //   },
        //   {
        //       title:'中华古壮字古籍库',
        //       ref:'zhonghua'
        //   },
        //   {
        //       title:'广西地方特色文献库',
        //       ref:'guangxidi'
        //   },
        //   {
        //       title:'广西经典文献当代转化库',
        //       ref:'guangxijing'
        //   },
        //   // {
        //   //     title:'中华古壮字字典',
        //   //     ref:'guzhuangzi'
        //   // },
        // ]
      }
    },
    methods: {
      backtop() {
        this.$el.querySelector(".header").scrollIntoView();
      },
      setBarWidth(item) {
        this.$router.push({path: '/resource/inbook', query: {ref: item.ref}})
      }

    },
    mounted() {
      const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
      if (this.$route.path == '/index') {
        this.$refs.main.$el.style = 'height:' + (document.documentElement.clientHeight - this.$refs.header.$el.offsetHeight) + 'px'
        const that = this
        let tid = null

        window.onresize = () => {
          return (() => {
            clearTimeout(tid);
            tid = setTimeout(()=>{
              window.fullHeight = document.documentElement.clientHeight - this.$refs.header.$el.offsetHeight
              that.fullHeight = window.fullHeight
              that.$refs.main.$el.style = "height:" + that.fullHeight + 'px'
            }, 400);
          })()
        }
      }
    },

    watch: {
      // fullHeight(val) {
      //   if (!this.timer) {
      //     this.fullHeight = val
      //     this.timer = true
      //     let that = this
      //     setTimeout(function () {
      //       that.timer = false
      //     }, 400)
      //   }
      // },
      '$route': function () {
        if (this.$route.path == '/index') {
          console.log(document.documentElement.clientHeight, this.$refs.header.$el.offsetHeight);
          this.$refs.main.$el.style = 'height:' + (document.documentElement.clientHeight - this.$refs.header.$el.offsetHeight) + 'px'
          const that = this
          window.onresize = () => {
            return (() => {
              window.fullHeight = document.documentElement.clientHeight - this.$refs.header.$el.offsetHeight
              that.fullHeight = window.fullHeight
              this.$refs.main.$el.style = "height:" + that.fullHeight + 'px'
            })()
          }
        } else {
          window.onresize = null
          this.$refs.main.$el.style = ''
        }
      }
    },
    created() {
      //设置临时调试端口
      // this.$store.commit("setTypeId", 0);
      this.$store.commit("setTypeId", 9017) //广西文库平台默认使用9017
      // this.$store.commit("setTypeId", window.location.port || 80)
    },
  };
</script>

<style lang="less" scoped>
  .el-header, .el-main, .el-footer {
    padding: 0 0px;
  }

  .headers {
    height: calc(4.167rem + 3.646rem) !important;
    &.is {
      height: calc(4.167rem + 3.646rem) !important;
    }
    &.detals{
      height: 4.167rem !important;
    }
  }

  .header {
    width: 100%;
    height: 4.167rem;
    background-color: #ffffff;
    background-image: url('../../assets/image/header/header_bg.png');
    // background-repeat: no-repeat;
    // background-size: cover;
  }

  ;
  .header-nav {
    display: flex;
    width: 100%;
    height: 3.646rem;
    background: url('../../assets/image/resource/header_top.png') no-repeat;
    background-size: cover;
    justify-content: center;
    align-items: center;
    font-size: 1.042rem;
    font-weight: bold;
    color: #ffffff;
    cursor: pointer;
    position: relative;

    .header-nva-item {
      margin-right: 2.083rem;
      padding-left: 1rem;
      z-index: 2;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }

  .footer {
    width: 100%;
    height: 15.625rem;
  }

  // .main {
  //   width: 100%;
  //   min-width: 84.375rem;
  //   flex-grow: 1;
  //   margin: auto;
  //   position: relative;
  // }

  //  首页 动画 鼠标滚轮 main 整页滚动
  .scollp {
    // scroll-snap-type: y mandatory;
    .el-header {
      position: fixed;
      width: 100%;
      z-index: 2010;
    }

    .header-nav {
      display: flex;
    }

    .el-main {
      margin-top: calc(3.646rem + 4.167rem);
      position: relative;
      overflow-y: hidden;
      scroll-snap-type: y mandatory;
      height: 44.635rem;
      background: unset;
      background-size: 100% 100%;
    }

    .el-footer {
      display: none;
    }
  }

  .el-main {
    background: url('../../assets/image/reader/common_bg.png') no-repeat;
    background-size: 100% 100%;
  }
</style>
